import { Theme } from "@mui/material";

const useStyles = (theme: Theme, split?: boolean) => {
  return {
    paper: {
      backgroundColor: theme.palette.background.default,
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
      borderRadius: 1,
      padding: 3,
      height: split ? "100%" : "fit-content",
      margin: 1.5,
    },
    switchFormControl: {
      width: "50%",
      display: "flex",
      alignItems: "start",
      justifyContent: "start",
    },
    switchLabel: {
      color: theme.palette.text.secondary,
      alignItems: "start",
      marginLeft: 0,
      "& .MuiFormControlLabel-label": {
        fontSize: "14px",
      },
    },
    radialContainer: {
      display: "flex",
      alignItems: "start",
      justifyContent: "space-between",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 2,
      height: "100%",
      width: "100%",
    },
    typographyOrientation: {
      position: "absolute",
      zIndex: 2,
      color: theme.palette.text.secondary,
      left: 15,
    },
    dividerContainer: {
      display: "flex",
      height: "100%",
    },
  };
};
export default useStyles;
